module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "konfigurator-jmeno-mazlicka"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm._f("translate")('We prepare Haffit for')) + ": " + _vm._s(_vm.mazlicek.jmeno.value))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validatejmeno() && _vm.tryescape),
      expression: "!validatejmeno() && tryescape"
    }],
    staticClass: "info-messages-box"
  }, [(!_vm.validatejmeno() && _vm.tryescape) ? _c('div', {
    staticClass: "error-msg"
  }, [_vm._v(_vm._s(_vm._f("translate")('Pet name is mandatory')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': !_vm.validatejmeno() && _vm.tryescape, 'has-success': _vm.validatejmeno() && _vm.tryescape
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mazlicek.jmeno.value),
      expression: "mazlicek.jmeno.value"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "jmeno",
      "placeholder": _vm._f("translate")('Write here how you call your dog')
    },
    domProps: {
      "value": (_vm.mazlicek.jmeno.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.mazlicek.jmeno, "value", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "infobox currently-configuring"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.currentCunfiguringVisitors)
    }
  })]), _vm._v(" "), _c('info', {
    attrs: {
      "krok": 1
    }
  }), _vm._v(" "), _c('navigace', {
    attrs: {
      "showNext": true,
      "disableNext": !_vm.valid,
      "onClickNext": _vm.next,
      "onClickSaveAndQuit": _vm.saveAndQuit
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b34aaf4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/01JmenoMazlicka.vue
// module id = 542
// module chunks = 1